import api from './api';
export const loadProductEditor = async (id = null) => (await api.get(id ? `/catalog/product-editor/${id}` : '/catalog/product-editor/bootstrap')).data;
export const saveProductEditor = async ({ id = null, payload, action = 'SAVE' }) => (id ? api.put(`/catalog/product-editor/${id}`, { ...payload, action }) : api.post('/catalog/product-editor', { ...payload, action })).then(response => response.data);

export const createStorefrontTaxonomy = async ({ storefront, type, payload }) => {
  const map = { category: 'categories', collection: 'collections', occasion: 'occasions', tag: 'tags' };
  const path = map[type];
  if (!path) throw new Error('Unsupported taxonomy type');
  return (await api.post(`/catalog/storefronts/${encodeURIComponent(storefront)}/${path}`, payload)).data;
};

export const createProductOptionGroup = async ({ storefront, payload, values = [] }) => {
  const group = (await api.post(`/catalog/storefronts/${encodeURIComponent(storefront)}/option-groups`, payload)).data;
  if (group?.id && Array.isArray(values)) await api.put(`/catalog/option-groups/${group.id}/values`, { values });
  return group;
};

export const createSellingUnit = async ({ code, label }) =>
  (await api.post('/catalog/product-editor/selling-units', { code, label })).data;

export const addStorefrontProductReview = async ({ storefront, productId, payload }) =>
  (await api.post(`/catalog/storefronts/${encodeURIComponent(storefront)}/reviews`, { product_id: productId, ...payload })).data;

export const updateStorefrontProductReview = async ({ reviewId, payload }) =>
  (await api.put(`/catalog/reviews/${reviewId}`, payload)).data;

export const deleteStorefrontProductReview = async (reviewId) =>
  (await api.delete(`/catalog/reviews/${reviewId}`)).data;

export const createInternalTag = async (payload) => (await api.post('/catalog/internal-tags', payload)).data;

export const listStorefrontCategories = async (storefront) =>
  (await api.get(`/catalog/storefronts/${encodeURIComponent(storefront)}/categories`)).data;

export const saveStorefrontCategory = async ({ storefront, id = null, payload }) =>
  (await (id
    ? api.put(`/catalog/storefronts/${encodeURIComponent(storefront)}/categories/${id}`, payload)
    : api.post(`/catalog/storefronts/${encodeURIComponent(storefront)}/categories`, payload)
  )).data;

export const deleteStorefrontCategory = async ({ storefront, id }) =>
  (await api.delete(`/catalog/storefronts/${encodeURIComponent(storefront)}/categories/${id}`)).data;
